module.exports = __webpack_public_path__ + "static/video3-6c11b5c1c5afc568a0fc1588a2c59bfe.mp4";